import vsezBanner from './assets/images/vsez.jpg';
import mos_Minister from './assets/images/Mos_Minister.jpeg';
import primeMinister from './assets/images/narendraModi.jfif';
import UnionMinister from './assets/images/piyushGoyal.png';
import vsezLogo from './assets/images/VSEZ_LOGO.png';

export const defaultData = {
  hero: {
    slides: [
      {
        image: vsezBanner,
        title: "Fuel your business in Visakhapatnam's vibrant hub!",
        subtitle: '"Unlocking Vizag\'s Economic Potential"',
        description: 'Experience seamless business opportunities and growth in the heart of Andhra Pradesh\'s economic powerhouse.'
      },
      {
        image: vsezBanner,
        title: "You do business and we take care of the rest",
        subtitle: "World-class infrastructure for your export needs",
        description: "The best of the facilities and incentives are now available under SEZ scheme."
      }
    ]
  },
  newsTicker: [
    {
      text: "• VSEZ-VACANCY-CIRCULAR-1-2024: Filling up of the post of Appraiser and Preventive Officer",
      fromDate: "2024-01-01",
      fromTime: "00:00",
      toDate: "2026-12-31",
      toTime: "23:59"
    },
    {
      text: "• Industries & Commerce(INF) Department G.O.Ms.No.151 Notification Published",
      fromDate: "2024-01-01",
      fromTime: "00:00",
      toDate: "2026-12-31",
      toTime: "23:59"
    },
    {
      text: "• CST REIMBURSEMENT FOR THE YEAR 2023-2024 Claims Settlement status updated",
      fromDate: "2024-01-01",
      fromTime: "00:00",
      toDate: "2026-12-31",
      toTime: "23:59"
    }
  ],
  ministers: [
    {
      name: 'Shri Narendra Modi',
      designation: "Hon'ble Prime Minister of India",
      image: primeMinister
    },
    {
      name: 'Shri Piyush Goyal',
      designation: "Hon'ble Minister of Commerce and Industry",
      image: UnionMinister
    },
    {
      name: 'Shri Jitin Prasada',
      designation: "Hon'ble Minister of State for Commerce and Industry",
      image: mos_Minister
    }
  ],
  quickLinks: [
    { title: 'GST', path: 'http://cbec.gov.in/' },
    { title: 'Tenders', path: '/tenders-detail/' },
    { title: 'Download Forms', path: '/downloads' },
    { title: 'Grievances', path: '/grievances' },
    { title: 'Related Links', path: '/related-links/' },
    { title: 'Citizen Charter', path: 'http://www.vsez.gov.in/app_doc/2020/Citizen%20Charter.pdf' }
  ],
  highlights: [
    {
      title: 'Customized Solutions',
      description: 'Tailored infrastructure and service solutions for your business needs.',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=400'
    },
    {
      title: 'Sustainability Initiatives',
      description: 'Green zone development with eco-friendly infrastructure and practices.',
      image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&fit=crop&q=80&w=400'
    },
    {
      title: 'Skill Development',
      description: 'Human resource development and training for enhanced productivity.',
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&q=80&w=400'
    },
    {
      title: 'Export Incentives',
      description: 'Competitive duty-free environment with significant financial benefits.',
      image: 'https://images.unsplash.com/photo-1521503862198-2ae9a997bbc9?auto=format&fit=crop&q=80&w=400'
    },
    {
      title: 'Investment Hub',
      description: 'A global gateway for foreign and domestic investment opportunities.',
      image: 'https://images.unsplash.com/photo-1454165833772-d996d49513d7?auto=format&fit=crop&q=80&w=400'
    },
    {
      title: 'Regulatory Compliance',
      description: 'Simplified procedures and single-window clearance for smooth operations.',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=400'
    }
  ],

  whatsNew: {
    circulars: [
      { title: "VSEZ-VACANCY-CIRCULAR-1-2024", link: "https://vsez.gov.in/wp-content/uploads/2024/11/VSEZ-VACANCY-CIRCULAR-1-OF-2024-1-1.pdf" },
      { title: "VSEZ-VACANCY-CIRCULAR-2-2024", link: "https://vsez.gov.in/wp-content/uploads/2024/11/VSEZ-VACANCY-CIRCULAR-2-OF-2024-1.pdf" },
      { title: "Vacancy Circular-Appraiser/Preventive Officer", link: "https://vsez.gov.in/wp-content/uploads/2024/11/Vacancy-Circular-Filling-up-of-the-post-of-Appraiser-and-Preventive-Officer-VSEZ.pdf" }
    ],
    notifications: [
      { title: "Industries & Commerce(INF) Dept G.O.Ms.No.151", link: "https://vsez.gov.in/wp-content/uploads/2024/11/goms151-sez-policy.pdf" },
      { title: "REVENUE (CT-III) DEPARTMENT G.O.Ms.No.370", link: "https://vsez.gov.in/wp-content/uploads/2024/11/GO-Ms.370-Stamps-Registration-dept_1.pdf" }
    ],
    meetings: [
      { title: "Agenda – 46th VSEZ Authority Meeting", link: "https://vsez.gov.in/wp-content/uploads/2024/11/Agenda-46th-VSEZ-Authority-Meeting.pdf" },
      { title: "193rd APPROVAL COMMITTEEs MEETING on 23.08.2024", link: "https://vsez.gov.in/wp-content/uploads/2024/11/Approved-Agenda-23.8.2024.pdf" }
    ]
  },
  welcome: {
    title: 'Welcome to Special Economic Zone (SEZ)',
    content: 'India was one of the first in Asia to recognize the effectiveness of the Export Processing Zone (EPZ) model in promoting exports, with Asia\'s first EPZ set up in Kandla in 1965. With a view to overcome the shortcomings experienced on account of the multiplicity of controls and clearances, absence of world-class infrastructure, and an unstable fiscal regime and with a view to attract larger foreign investments in India, the Special Economic Zones (SEZs) Policy was announced in April 2000.',
    image_url: vsezLogo
  },
  gallery: [
    { id: 1, title: 'Madras EPZ', image_url: 'https://images.unsplash.com/photo-1520641322165-547df2ad22e0?auto=format&fit=crop&q=80&w=400' },
    { id: 2, title: 'Falta SEZ', image_url: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80&w=400' },
    { id: 3, title: 'Visakhapatnam SEZ', image_url: 'https://images.unsplash.com/photo-1605152276897-4f618f831968?auto=format&fit=crop&q=80&w=400' },
    { id: 4, title: 'Kandla SEZ', image_url: vsezLogo }
  ]
};
